module.exports = __webpack_public_path__ + "static/media/homepage-banner-incentives.5eff08f7.jpg";